<a class="nav-link nav-flag" href="#" data-toggle="dropdown" aria-expanded="false" role="button" [attr.aria-label]="langSelected">
	<img [src]="flags[lang]" [alt]="langSelected" class="nav-flag__img">
</a>

<div class="dropdown-menu dropdown-menu-sm dropdown-menu-right flag" style="left: inherit; right: 0px">
	<!-- <li class="header"> {{ translate.instant('PAGES.selectLanguage') }} </li> -->
	<span class="dropdown-header">{{ translate.instant('PAGES.selectLanguage') }} </span>
	
	<a href="#" (click)="changLang('pt');hideMl()" class="dropdown-item">
		<img src="/assets/icon/flag/pt.svg">
		{{ portuguese }}
	</a>
	<a href="#" (click)="changLang('en');hideMl()" class="dropdown-item">
		<img src="/assets/icon/flag/en.svg">
		{{ english }}
	</a>
	<a href="#" (click)="changLang('es');hideMl()" class="dropdown-item">
		<img src="/assets/icon/flag/es.svg">
		{{ spanish }}
	</a>
	<a href="#" (click)="changLang('fr');hideMl()" class="dropdown-item">
		<img src="/assets/icon/flag/french.svg">
		{{ french }}
	</a>

	<!-- <div class="flag">
		<li>
			<ul class="">
				
			</ul>
		</li>
	</div> -->
</div>